
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { PerformanceView } from '../praxis-call/components/PerformanceView';


const COLORS = ['#7B2928', '#C1C9CD'];

const data = {
    "audio_file": "sampleaudio/b2d596a2-d497-449a-b49b-ffeaad5509e9_20250306T00_16_UTC_test_for_assembly.wav",
    "transcript": "\nSpeaker B: Hello?\nSpeaker A: Hey, my name is Cam. I'm with community Health workers with Syncare, and I wanted to check in on you after your hospital stay. How are you feeling today?\nSpeaker B: I have been better, definitely. But, yeah, I'm recovering.\nSpeaker A: Okay. I'm glad to hear that. As a part of your follow up care, I'd like to ask a few questions about things that might affect your recovery, like housing, food, transportation. These help us connect you to any resources that might be helpful. Does that sound okay?\nSpeaker B: Yeah, it sounds okay.\nSpeaker A: Okay. All right, so if we stop the call here? Let's hang up the call.",
    "analysis": {
        "Professional Communication": {
            "score": 6,
            "feedback": "The health worker maintained a professional tone and used appropriate vocabulary and terminology such as 'follow up care' and 'resources.' However, there was a noticeable lack of clear explanations about the specifics of the follow-up process or the role of Syncare. The conversation was prematurely terminated, indicating a lapse in professionalism."
        },
        "Empathy and Rapport": {
            "score": 7,
            "feedback": "The health worker displayed active listening by acknowledging the patient's response about feeling better and recovering. However, there was minimal emotional acknowledgment or compassionate responses to the patient's current health status. More empathy could be demonstrated through reassuring language or expressing concern about the patient's situation."
        },
        "Call Structure and Flow": {
            "score": 4,
            "feedback": "The call started with a clear introduction and a logical progression of asking for consent to discuss the patient's recovery needs. However, the call abruptly ended without proper closure, disrupting the flow. A proper closure with a farewell or summary of next steps was necessary."
        },
        "Patient Education and Engagement": {
            "score": 5,
            "feedback": "There was an attempt to involve the patient by asking if discussing needs was okay, indicating some level of engagement. However, there was no verification of understanding or clear explanation about how the patient's input would influence their care. More interactive engagement and educational insight into the process were needed."
        }
    },
    timestamp: "2025-03-12T09:15:13.720339",
};

export function CallReport() {
    const radarData = Object.keys(data.analysis).map((key) => ({
        subject: key,
        A: data.analysis[key].score,
    }));
    const sum = Object.values(data.analysis).reduce((acc, curr) => acc + curr.score, 0);
    const avg = sum / Object.keys(data.analysis).length;
    const pieData = [
        { name: "score", value: avg },
        { name: "score", value: 10 - avg }
    ]
    return (
        <div className='p-4'>
            <div className="flex flex-row gap-4 w-full">
                <div className='flex justify-center items-center'>
                    <div className='flex flex-col gap-4 items-center justify-center'>
                        <h3 className='text-lg font-bold mb-4'>Overall Score</h3>
                        <PieChart width={300} height={300} className='relative'>
                            <Pie
                                data={pieData}
                                cx={150}
                                cy={150}
                                innerRadius={60}
                                outerRadius={80}
                                fill="#8884d8"
                                paddingAngle={0}
                                dataKey="value"
                            >
                                {pieData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" color='#7B2928' className='text-2xl text-primary font-bold'>{avg.toFixed(1)} / 10</text>
                            <text x="50%" y="60%" textAnchor="middle" dominantBaseline="middle" color='#7B2928' className='text-sm text-primary font-bold'>{(avg * 100) / 10}%</text>
                        </PieChart>
                    </div>
                </div>
                <div className='flex-1'>

                    <ResponsiveContainer width={900} height={500}>
                        <RadarChart cx="40%" cy="40%" outerRadius="60%" data={radarData}>
                            <PolarGrid gridType="circle" />
                            <PolarAngleAxis dataKey="subject" />
                            <PolarRadiusAxis />
                            <Radar name="Mike" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                        </RadarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div className='mt-4'>
                <h3 className='text-lg font-bold mb-4'>Detailed Feedback</h3>
                <div className='flex flex-col gap-4'>
                    {
                        Object.keys(data.analysis).map((key) => (
                            <div key={key} className='flex flex-col gap-2 shadow-lg p-4 rounded-md border-l-[4px] border-l-primary'>
                                <PerformanceView
                                    title={`${key} - ${data.analysis[key].score}/10 (${(data.analysis[key].score * 100) / 10}%)`}
                                    value={(data.analysis[key].score * 100) / 10}
                                />
                                <p>{data.analysis[key].feedback}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>);
}
